import { tracked } from '@glimmer/tracking';
import type { MatchParticipantInsights } from '../../types/secure-your-future';
import { isNullish } from '../../utils/is-nullish';
import type { MatchParticipant, SyfEnrollmentState } from './match-participant.type.ts';
export interface MatchParticipantExtension extends MatchParticipant {}
export class MatchParticipantExtension {
  @tracked insights?: MatchParticipantInsights;

  get preEnrollmentStates(): Set<SyfEnrollmentState> {
    return new Set(['SYF.EnrollmentState.NOT_STARTED']);
  }

  get pendingEnrollmentStates(): Set<SyfEnrollmentState> {
    return new Set(['SYF.EnrollmentState.DRAFT']);
  }

  get completedEnrollmentStates(): Set<SyfEnrollmentState> {
    return new Set(['SYF.EnrollmentState.MISSING_INFORMATION', 'SYF.EnrollmentState.COMPLETE']);
  }

  get isEnrolling() {
    return this.pendingEnrollmentStates.has(this.enrollmentState);
  }

  get isEnrolled() {
    return this.completedEnrollmentStates.has(this.enrollmentState);
  }

  get enrollmentDate(): string | undefined {
    const enrolledStates = [
      'SYF.EnrollmentState.COMPLETE',
      'SYF.EnrollmentState.MISSING_INFORMATION',
    ];
    const logItem = this.transitionLog.find((logItem) => enrolledStates.includes(logItem.to));
    return logItem?.timestamp;
  }

  get reportedSalaryInDollars() {
    return this.reportedSalary / 100;
  }

  get reportedMonthlyPaymentInDollars() {
    return this.reportedMonthlyPayment / 100;
  }

  get hasDataForInsights() {
    return !(isNullish(this.reportedSalary) || isNullish(this.reportedMonthlyPayment));
  }
}

const Registration = {
  kind: 'object',
  name: 'match-participant',
  features: MatchParticipantExtension,
};
export default Registration;
